export default __webpack_public_path__ + "assets/LUCAS_DA_SILVA_COSTA-DESENVOLVEDOR-CV_EN.cd181ba9.pdf";